export default __webpack_public_path__ + "static/media/12-32-16.bf43a100.jpg";